import { render } from "./ShoppingBagIcon.vue?vue&type=template&id=1b50f32a&scoped=true"
import script from "./ShoppingBagIcon.vue?vue&type=script&lang=js"
export * from "./ShoppingBagIcon.vue?vue&type=script&lang=js"

import "./ShoppingBagIcon.vue?vue&type=style&index=0&id=1b50f32a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b50f32a"]])

export default __exports__